import { createRouter, createWebHistory } from 'vue-router'
import { throttle } from 'lodash-es'
import needLayoutRouter from './needLayoutRouter'
import noLayoutRouter from './noLayoutRouter'
import { useDfansHead } from '@/composables/useDfansHead'
import { unlockAppScroll } from '@/utils/scroll-lock-manager'

const routes: any = [
  {
    path: '/',
    name: 'Login',
    alias: '/login',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import(/* webpackPrefetch: true */ '@/views/login/index.vue'),
  },
  needLayoutRouter,
  ...noLayoutRouter,
  {
    path: '/chats',
    component: () => import('@/components/Layout/index.vue'),
    children: [
      {
        path: '/chats',
        name: 'messageBoard',
        meta: {
          needLogin: true,
          // isKeepAlive: true,
          title: 'messageBoard',
        },
        component: () => import('@/views/chats/index.vue'),
        children: [
          {
            path: 'chat/:privateChatId',
            name: 'messageDetail',
            meta: {
              needLogin: true,
              // isKeepAlive: true,
              title: 'messageDetail',
            },
            component: () => import('@/views/chats/messageDetail.vue'),
          },
          {
            path: 'chat/:privateChatId/gallery',
            name: 'Gallery',
            meta: {
              needLogin: true,
              title: 'Gallery',
            },
            component: () => import('@/views/chats/ChatGallery.vue'),
          },
        ],
      },
      {
        path: 'AiChatsbot',
        name: 'AiChatsbot',
        meta: {
          needLogin: true,
          title: 'aiChatsbot',
        },
        component: () => import('@/views/chats/aiChatsbot.vue'),
      },
      {
        path: 'newChatsSend',
        name: 'NewChatsSend',
        meta: {
          needLogin: true,
          title: 'newChatsSend',
        },
        component: () => import('@/views/chats/newChatsSend.vue'),
      },
      {
        path: 'newChats',
        name: 'NewChats',
        meta: {
          needLogin: true,
          title: 'newChats',
        },
        component: () => import('@/views/chats/newChatsDetail.vue'),
      },
    ],
  },
]
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to: any, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // 如果返回到 Home，恢复存储的滚动位置
    if (to.meta.keepScroll && to.meta.scrollTop !== undefined) {
      return { top: to.meta.scrollTop }
    }
    // 默认滚动到顶部
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const {
    meta: { needLogin },
    name,
  } = to
  const userStore = useUserStore()
  const { isLogin } = userStore
  const { isTelegram } = useTelegram()

  if (from.meta.keepScroll) {
    from.meta.scrollTop = document.body.scrollTop || document.documentElement.scrollTop
  }
  if (isTelegram) {
    next()
  } else if (needLogin && !isLogin) {
    if (name === 'Login') {
      return next()
    }
    if (name === 'KYC') {
      return next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      })
    }
    next({
      name: 'Login',
    })
  } else {
    const routeArray = ['Creators', 'BecomeCreator']
    if (routeArray.includes(from.name as string) || routeArray.includes(to.name as string)) {
      const { addTrack } = useReport()
      addTrack({
        event: 'page_visit',
        extra: {
          creatorDomain: to.params.domain,
        },
        page: window.location.origin + to.path,
        referrer: window.location.origin + from.path,
        timestamp: Date.now(),
      })
    }
    next()
  }
})
const throttledNotification = throttle(() => {
  useUserStore().SET_MESSAGE_NOTIFICATION()
}, 30000)

router.afterEach((to, from) => {
  const userStore = useUserStore()
  const title = to.meta?.title
  if (to.name !== 'Home') {
    document.body.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  if (from.meta.keepScroll) {
    from.meta.scrollTop = document.body.scrollTop || document.documentElement.scrollTop
  }
  if (title) {
    useDfansHead({
      title,
    })
  }
  const { isLogin } = userStore
  if (isLogin) {
    throttledNotification()
  }
  cancelAllRequest()
  unlockAppScroll() // 确保在路由切换后，解锁页面滚动
})
export default router
